import { combineReducers } from 'redux';
import { some } from './mock/some';

const getStartedGames = (resp) => resp.filter(({ started }) => started);

const all = (state = some, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return action.resp.games;
    default:
      return state;
  }
};

const noGamesStarted = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getStartedGames(action.resp.games).length === 0;
    default:
      return state;
  }
};

const allGamesStarted = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_PLAYER_DATA_SUCCESS':
    case 'SET_PLAYER_PICKS_SUBMITTED':
      return getStartedGames(action.resp.games).length === action.resp.games.length;
    default:
      return state;
  }
};

const hasGamesToday = (state = true, action) => {
  switch (action.type) {
    case 'SET_NO_CONTEST_TODAY':
      return false;
    default:
      return state;
  }
};

export default combineReducers({
  all,
  noGamesStarted,
  allGamesStarted,
  hasGamesToday,
});
